import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import API_CONFIG from '../../config/config'
import { getCartDataObject } from './helper/cart';
import isEmpty from 'lodash/isEmpty';

const { apiURL } = API_CONFIG;

export const createCart = createAsyncThunk(
  'plans/createCart',
  async (cartLines = [], { getState }) => {
    const state = getState();
    const request = await axios.post(apiURL + `/signup/cart/`, {
      signup: state.user?.signUpData?.id,
      plan: state.user?.planId,
      cart_lines: cartLines,
    });
    return request?.data;
  }
);

export const getCartData = createAsyncThunk(
  'plans/getCart',
  async (_, { getState, dispatch }) => {
    const state = getState();
    const request = await axios.get(apiURL + `/signup/${state.user?.signUpData?.id}/cart/`); 
    const cartData = request?.data;
    const signupData = cartData.signup;
    signupData && dispatch({ type: "user/setSignupData" , payload: signupData });
    const cart = getCartDataObject(cartData);
    return cart;
  }
);

export const updateCart = createAsyncThunk(
  'plans/updateCart',
  async (data) => {
    const request = await axios.put(apiURL + '/signup/cart/', data) 
    const cartData = request?.data;
    const cart = getCartDataObject(cartData);
    return cart;
  }
);

const cart = createSlice({
    name: 'cart',
    initialState: {},
    reducers: {
      clearCart: () => ({}),
      clearCartLines: (state) => {
        if(!state || isEmpty(state)) return;
        state.cartLines = [];
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(createCart.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(createCart.fulfilled, (_, action) => {
          return {
            ...action.payload,
            loading: false,
            error: null
          };
        })
        .addCase(createCart.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        .addCase(getCartData.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(getCartData.fulfilled, (_, action) => {
          return {
            ...action.payload,
            loading: false,
            error: null
          };
        })
        .addCase(getCartData.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        })
        .addCase(updateCart.pending, (state) => {
          state.loading = true;
          state.error = null;
        })
        .addCase(updateCart.fulfilled, (_, action) => {
          return {
            ...action.payload,
            loading: false,
            error: null
          };
        })
        .addCase(updateCart.rejected, (state, action) => {
          state.loading = false;
          state.error = action.error.message;
        });
    }
})

export const { clearCart, clearCartLines } = cart.actions
export default cart.reducer;